/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpMobileStarRating_reviews$ref: FragmentReference;
export type PdpMobileStarRating_reviews = {|
  +totalResults: ?number,
  +$refType: PdpMobileStarRating_reviews$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpMobileStarRating_reviews",
  "type": "SellerOrderFeedbackPdpQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6da7d4ab6873ad4dcba9e7a3eb6aa1e2';
module.exports = node;
